import { Inject, Injectable, InjectionToken, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { ApolloError } from '@apollo/client/core';
import { ErrorResponseService, RootErrorHandler } from '@x/common/error';

export const ROOT_MODULE_ERROR_HANDLER = new InjectionToken<RootModuleErrorHandlerProvider>(
  'ROOT_MODULE_ERROR_HANDLER',
);

export interface RootModuleErrorHandlerProvider {
  handleApolloError: (error: ApolloError) => Promise<any>;
}

@Injectable()
export class ShopErrorHandlerService extends RootErrorHandler {
  constructor(
    errorResponse: ErrorResponseService,
    private router: Router,
    @Optional()
    @Inject(ROOT_MODULE_ERROR_HANDLER)
    private newHandler: RootModuleErrorHandlerProvider,
  ) {
    super(errorResponse);
  }

  async handleApolloError(error: ApolloError) {
    if (this.newHandler) {
      return await this.newHandler.handleApolloError(error);
    }

    super.handleApolloError(error);
  }
}
